"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var API_1 = require("../../API");
var lodash_1 = require("lodash");
exports.BIRCHMOUNT_BASE_URL_DEV = 'https://dev.budspos.com/services';
var BirchmountStatus;
(function (BirchmountStatus) {
    BirchmountStatus["SUCCESS"] = "SUCCESS";
    BirchmountStatus["FAILURE"] = "FAILURE";
    BirchmountStatus["DEBUG"] = "DEBUG";
})(BirchmountStatus = exports.BirchmountStatus || (exports.BirchmountStatus = {}));
exports.convertBalanceToNumber = function (response) {
    var numericBalance = response.BALANCE === null
        ? null
        : Number(response.BALANCE.replace('$', '')) * 100;
    return __assign({}, response, { BALANCE: numericBalance });
};
var BirchmountStore = /** @class */ (function () {
    function BirchmountStore(accessToken) {
        var _this = this;
        this.checkBalance = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.BirchmountAPI.checkBalance(this.accessToken, params)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
        this.activate = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.BirchmountAPI.activate(this.accessToken, params)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
        this.redeem = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.BirchmountAPI.redeem(this.accessToken, params)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
        this.reload = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.BirchmountAPI.reload(this.accessToken, params)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
        this.reverse = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.BirchmountAPI.reverse(this.accessToken, params)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
        this.getLocationIds = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, API_1.BirchmountAPI.getLocationIds(undefined, this.accessToken)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        }); };
        this.accessToken = accessToken;
    }
    BirchmountStore.cardDigitCount = 19;
    BirchmountStore.pinDigitCount = 4;
    BirchmountStore.maxCentValue = 25000;
    BirchmountStore.isCreditValid = function (credit) {
        return 0 < credit && credit <= BirchmountStore.maxCentValue;
    };
    BirchmountStore.isCardNumberValid = function (cardNumber) {
        if (lodash_1.isNil(cardNumber)) {
            return false;
        }
        return cardNumber.length === BirchmountStore.cardDigitCount;
    };
    BirchmountStore.isPinValid = function (pin) {
        if (lodash_1.isNil(pin)) {
            return false;
        }
        return pin.length === BirchmountStore.pinDigitCount;
    };
    return BirchmountStore;
}());
exports.BirchmountStore = BirchmountStore;
//# sourceMappingURL=Birchmount.js.map